require("./init");

import Form from "./form";

import ExtensionService from "live/services/extension";

const _plugin = {
  name: "lookup pipes",
  type: "plugin-lookup-pipes",
  origin: "Lookup Pipes",
  icon: "/content/plugin-lookup-pipes/logo_48x28.png",
  ui: {
    form: Form,
    view: null,
  },
};

ExtensionService.register(_plugin);
